define('components/stratemanager/models/StrateManagerModel', [

], function() {

    var StrateManagerModel = Backbone.Model.extend({
        defaults: {
            "attach": "body",               // Selector $ to attach strate wrapper
            "showMainNav": true,            // Show / Hide default nav
            "shareConf": null,              // Config of the share. See ShareModel for more informations
            "invertScroll": false,          // If scroll goes bottom to top
            "onReady": null                 // Callback when all strates are ready
         }
    });

    return StrateManagerModel;
});
